export default __webpack_public_path__ + "static/media/Venturer's Chestguard of the Roaring Jungle.a9d97845.jpg";